import React, { type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

function LibModalListHeader({ children }: Props) {
  return (
    <div className="flex h-50 items-center bg-white-light px-20">
      {children}
    </div>
  );
}

export default LibModalListHeader;
